<template>
  <v-dialog :value="show" max-width="500px" persistent>
    <v-card>
      <v-card-title class="justify-center">
        <span class="text-h5 sp">{{ $t('version_update.title') }}</span>
      </v-card-title>
      <v-card-text class="text-center">
        {{ $t('version_update.text') }}
      </v-card-text>
      <v-card-actions class="justify-center pb-4">
        <v-btn color="orange darken-3" rounded outlined @click="reload">
          {{ $t('version_update.button') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AppUpdateModal',
  computed: {
    ...mapState({
      show: ({ versionUpdate }) => versionUpdate.show,
    }),
  },
  methods: {
    reload() {
      window.location.reload();
    },
  },
};
</script>
